
//引入接口文档
import req from '@/utils/req.js'
//开放科室列表查询
export function getdepartment(params, payload) {
  return req.post(`/admin/${payload}-department/list`, params)
}
//开放科室添加
export function postDepartment(params, payload) {
  return req.post(`/admin/${payload}-department`, params)
}
//开放科室详细查询
export function getDepartmentDetail(params, payload) {
  return req.get(`/admin/${payload}-department/${params}`)
}

//开放科室删除
export function deleteDepartment(params) {
  return req.delete(`/admin/open-department/${params}`)
}

//医院列表查询
export function getHospital(params = {}) {
  return req.post(`/admin/hospital/list`, params)
}


//开放科室更新
export function putDepartment() {
  return req.put('/admin/open-department')
}

//开放科室下移
export function moveDown(params, payload) {
  return req.post(`/admin/${payload}-department/${params}/moveDown`)
}

//开放科室上移
export function moveUp(params, payload) {
  return req.post(`/admin/${payload}-department/${params}/moveUp`)
}


//标准科室列表查询
export function getStandard(params) {
  return req.get(`/admin/standard-department`, params)
}

//资质上传
export function submitCertificate(params) {
  return req.post(`/admin/doctor/submitCertificate`, params)
}
//资质审核
export function approvalCertificate(params) {
  return req.post(`/admin/doctor/approvalCertificate`, params)
}
// 医护团队服务方案列表
export function byTeamId(params) {
  return req.get(`/admin/team-service/byTeamId/${params}`)
}
//微信永久素材上传
export function wechatUpload(params) {
  return req.post(`/dsicm-contact-platform/feign/file/wechat/upload`, params)
}
//获取所有地区列表
export function regionAll(params) {
  return req.get(`/patient/region/all`, params)
}

//平台医院分页查询
export function platform(params) {
  return req.post(`/admin/platform/page`, params)
}
//医院添加
export function addPlatform(params) {
  return req.post(`/admin/platform`, params)
}

//医院修改
export function putPlatform(params) {
  return req.put(`/admin/platform`, params)
}

//平台禁用
export function disable(params) {
  return req.post(`/admin/platform/${params}/disable`)
}

//平台启用
export function enable(params) {
  return req.post(`/admin/platform/${params}/enable`)
}

//平台禁用
export function hospitalDisable(params) {
  return req.post(`/admin/hospital/${params}/disable`)
}

//平台启用
export function hospitalEnable(params) {
  return req.post(`/admin/hospital/${params}/enable`)
}

//平台医院列表查询
export function getPlatformList(params = {}) {
  return req.post(`/admin/platform/list`, params)
}

//平台科室列表查询
export function getPlatformDepartmentList(params) {
  return req.post(`/admin/platform-department/list`, params)
}

// 团队科室列表查询
export function getHospitalDepartmentList(params) {
  return req.post(`/admin/open-department/list`, params)
}

export function getPlatformOpenDepartmentList(params) {
  return req.post(`/admin/open-department/list`, params)
}
//线下机构是否有医护服务权限
export function getHaveNursingService(params) {
  return req.get(`/admin/hospital/haveNursingService/${params}`)
}

//医生平台添加
export function addDoctorPlatform(params) {
  return req.post(`/admin/doctor-platform`, params)
}
//医生平台删除
export function deleteDoctorPlatform(params) {
  return req.delete(`/admin/doctor-platform/${params}`)
}

//根据医生ID查询平台列表

export function getListByDoctorId(params) {
  return req.get(`/admin/doctor-platform/listByDoctorId/${params}`)
}

//用户选项列表，树结构
export function userSelectTree(params) {
  return req.get(`/admin/user/selectTree`, params)
}

//医生选项列表，树结构
export function doctorSelectTree(params) {
  return req.get(`/admin/doctor/selectTree`, params)
}

//病人列表分页条件查询
export function searchPatient(params) {
  return req.post(`/admin/patient/page`, params)
}
//给患者批量推送
export function searchPush(params) {
  return req.post(`/admin/scheme/push`, params)
}

//医生团队二维码详细查询
export function Teamqrcode(params) {
  return req.get(`/admin/doctor-team-qrcode/${params}`)
}

//平台绑定微信应用列表获取
export function wechatPlatform(params) {
  return req.get(`/admin/wechat-app/type/platform`, params)
}

//平台Id加应用类型获取平台管理的微信应用
export function platformIdType(params) {
  return req.get(`/admin/platform-wechat-app/platform-id-type`, params)
}
//
// /admin/doctor-scheme/page
//获取医生匾联列表
export function doctorScheme(params) {
  return req.get(`/admin/doctor-scheme/page`, params)
}
//获取服务分配的详情页数据
export function getDoctorNursingDetail(params) {
  return req.get(`/admin/doctor/getDoctorNursingDetail`, params)
}
//分配医护上面服务
export function getdistribute(params) {
  return req.post(`/admin/doctor-nursing/distribute`, params)
}

//关联监管部门
export function getSupervisionList(params) {
  return req.post(`/dsicm-supervision/feign/basic/list`, params)
}
export function setAsExpertTeam(params) {
  return req.put(`/admin/doctor-team/setAsExpertTeam/${params.id}/${params.value}`)
}
export function setAsTop(params) {
  return req.put(`/admin/doctor-team/setAsTop/${params.id}/${params.value}`)
}

export function hospital_new_level(params) {
  return req.get(`/admin/category/hospital_new_level/children`)
}
export function doctorNurseCreate(params) {
  return req.post(`/admin/user/create/doctor`, params)
}
export function doctorTeamCreate(params) {
  return req.post(`/admin/doctor-team`, params)
}
export function doctorSearch(params) {
  return req.post(`/admin/doctor/search2`, params)
}
export function addMemberSearch(params) {
  return req.post(`/admin/doctor/addMemberSearch`, params)
}
//医院列表查询
export function getHospitalList(params) {
  return req.get("/admin/hospital", params)
}

export function doctorUpdate(params) {
  return req.put(`/admin/doctor-team`, params)
}
export function doctorSearch1(params) {
  return req.post(`/admin/doctor-scheme/search`, params)
}
export function AdddoctorMember(params) {
  return req.post(`/admin/doctor-team-member`, params)
}
export function doctorMemberDelete(params) {
  return req.delete(`/admin/doctor-team-member/${params.id}`)
}
export function setAsLeader(id) {
  return req.put(`/admin/doctor-team-member/setAsLeader/${id}`)
}
export function setAsMatron(id) {
  return req.put(`/admin/doctor-team-member/setAsMatron/${id}`)
}
export function AddService(params) {
  return req.post(`/admin/team-service`, params)
}
export function UpdateService(params) {
  return req.put(`/admin/team-service`, params)
}
export function updateByOriginalPrice(params) {
  return req.put(`/admin/team-service/updateByOriginalPrice`, params)
}

export function getServiceByTeamId(params,params1=false) {
  return req.get(`/admin/team-service/byTeamId/${params}?experiencePack=${params1}`)
}
export function getTherapistByTeamId(params) {
  return req.get(`/admin/team-service/getTherapistByTeamId/${params}`)
}

export function setAsRecommend(params) {
  return req.put(`/admin/team-service/setAsRecommend/${params.id}/${params.value}`)
}
export function doctorServiceDelete(params) {
  return req.delete(`/admin/team-service/${params}`)
}
export function checkIdCardNumber(params, name) {
  return req.post(`/admin/user/checkIdCard?number=${params}&name=${name}`)
}

export function doctor_title(type) {
  return req.get(`/admin/category/doctor_title/children/${type}`)
}
export function setAsExecutive(params) {
  return req.put(`/admin/doctor-team-member/setAsExecutive?id=${params}`)
}
export function setAsMdt(params) {
  return req.put(`/admin/doctor-team-member/setAsMdt?id=${params}`)
}

export function feedbackList(params, name) {
  return req.post('/admin/opinion-feedback/page', params)
}

export function getFeedbacKDetails(params) {
  return req.get(`/admin/opinion-feedback/look/${params}`)
}

export function replyFeedbacK(params) {
  return req.put('/admin/opinion-feedback/reply', params)
}
export function getPlateFormList(params) {
  return req.post('/admin/platform/page2', params)
}
export function getPlateFormDetails(params) {
  return req.get(`/admin/platform/${params}`, {})
}
export function getWechatList(params) {
  return req.get(`/admin/wechat-app/type/platform`, params)
}
export function platePageList(params) {
  return req.post('/admin/hospital/pageListByPlatformId', params)
}

export function institutionResetPassword(params) {
  return req.put('/admin/user/reset/password/'+params)
}
export function getHospitalQrCode(params) {
  return req.post('/admin/doctor-team-qrcode/getHospitalQrCode', params)
}
export function setEnterEndTime(params) {
  return req.post('/admin/hospital/setEnterEndTime', params)
}
export function platformList(params) {
  return req.post('/admin/platform/list', {})
}
export function checkBankCard(params) {
  return req.get('/admin/bank/checkBankCard/'+params)
}
export function getHospitalById(params) {
  return req.get('/admin/hospital/'+params)
}
export function listPullDown(params) {
  return req.post('admin/hospital/listPullDown', {})
}
export function changePeriodOrPrice(params) {
  return req.put(`/dsicm-api/feign/doctor-team/changePeriodOrPrice/${params.id}/${params.value}`)
}
export function allHospital(params) {
  return req.post('/admin/hospital/allHospital', params)
}
export function getAllTherapistScheme(params) {
  return req.post('/admin/scheme/getAllTherapistScheme', params)
}
export function saveCourseManageTeam(params) {
  return req.post('/admin/doctor-team/saveCourseManageTeam', params)
}
export function getStrategicDiseaseAndWechat(params) {
  return req.get('/patient/disease-following/getStrategicDiseaseAndWechat', params)
}
export function getCourseManageTeam(params) {
  return req.get('/admin/doctor-team/getCourseManageTeam', params)
}
export function getCourseManageMediaList(params) {
  return req.get('/admin/disease-type/getCourseManageMediaList', params)
}
export function getCourseManageMediaDetail(params) {
  return req.get('/admin/disease-type/getCourseManageMediaDetail', params)
}
export function updateCourseManageMedia(params) {
  return req.post('/admin/disease-type/updateCourseManageMedia', params)
}

//科室资料配置列表查询
export function pageForDepartment(params) {
  return req.post('/admin/focusFieldConfig/pageForDepartment', params)
}
//科室资料配置列表详情
export function pageForDepartmentDetail(params) {
  return req.get(`/admin/focusFieldConfig/department/detail/${params.id}`)
}


//资料配置新增
export function saveConfig(params) {
  return req.post('/admin/focusFieldConfig/saveConfig', params)
}
//资料配置编辑
export function updateConfig(params) {
  return req.post('/admin/focusFieldConfig/updateConfig', params)
}


//重点字段分组添加
export function saveGroup(params) {
  return req.post('/admin/focusFieldGroup/save', params)
}

//删除分组
export function deleteGroup(params) {
  return req.post('/admin/focusFieldGroup/deleteGroup', params)
}

//团队配置 科室配置 -标准字段下拉
export function standardpPage(params) {
  return req.post('/admin/standard-field/page', params)
}



//团队配置 科室配置 -一级下拉
export function getParentGroupDropList(params) {
  return req.post('/admin/focusFieldGroup/getParentGroupDropList', params)
}

//团队配置 科室配置 -根据一级获取二级下拉
export function getChildGroupList(params) {
  return req.post('/admin/focusFieldGroup/getChildGroupList', params)
}

//管理分组列表
// export function manageList(params) {
//   return req.post('/admin/focusFieldGroup/manage', params)
// }

//团队资料配置检索
export function commonQuery(params) {
  return req.post('/admin/focusFieldConfig/commonQuery', params)
}


//根据选择医院获取科室列表
export function getListByHospitalId(params) {
  return req.post("/admin/open-department/list",params);
} 

//管理分组列表
export function manageList(params) {
  return req.post('/admin/focusFieldGroup/queryAll', params)
}


//下载模板
export function focusFieldExcelDemo(params) {
  return req.post('/admin/focusFieldConfig/download/focusFieldExcelDemo', params,{ responseType:'arraybuffer' })
}

//列表拖拽
export function focusFieldConfigDetail(params) {
  return req.post('/admin/focusFieldConfig/move/focusFieldConfigDetail', params)
}

//分组拖拽
export function focusFieldGroup(params) {
  return req.post('/admin/focusFieldConfig/move/focusFieldGroup', params)
}

export function focusFieldExcelData(params) {
  return req.post(`/admin/focusFieldConfig/upload/focusFieldExcelData`,params)
}

//分组拖拽
export function getFocusFieldConfigDetail(params) {
  return req.post('/admin/focusFieldConfig/getFocusFieldConfigDetail', params)
}



export function getUnits(params) {
  return req.get('/admin/focusFieldConfig/getUnits', params)
}


// 设置前端展示
export function updatePatientShow({id, show}) {
  return req.put(`/admin/team-service/patient-show/${id}/${show}`)
}

// 创建完成接口 
export function postSimpleDoctor(params) {
  return req.post('/admin/user/create/simpleDoctor', params)
}




